import React, { useState, useEffect } from 'react';
import '../Dashboard/dashboard.scss';
import { Link } from 'react-router-dom';
// import { Row, Col } from 'react-bootstrap';
import { useLazyQuery } from '@apollo/client';
import { GET_DASHBOARD_CHECK } from '../../gql/auth/queries';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

function Dashboard() {
    // const [emailVerified, setEmailVerified] = useState('') 
    const [campaignCreated, setCampaignCreated] = useState('')
    const [campaignSent, setCampaignSent] = useState('')
    const [emailProvider, setEmailProvider] = useState('')
    // const [errorMessage, setErrorMessage] = useState('')
    const [requestDashboardCheck] = useLazyQuery(GET_DASHBOARD_CHECK, {
        onCompleted(data) {
            setCampaignCreated(data?.getUserDashboardData?.campaignCreated)
            setCampaignSent(data?.getUserDashboardData?.campaignSent)
            setEmailProvider(data?.getUserDashboardData?.emailProvider)
        },
        fetchPolicy: 'network-only'
    })

    useEffect(() => {
        requestDashboardCheck()

        //eslint-disable-next-line
    }, [])

    // if(errorMessage){
    //     toast.error(errorMessage, {
    //       position: "bottom-right",
    //     })
    //     setErrorMessage('')
    // }

    return (
        <div className='dashboard-inner'>
            <div className='steps-container'>
                <div className='title-container'>
                    <h1>Your Quick Start Guide</h1>
                    {/* <Link to="/#">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.6667 8.77745V13.4441C12.6667 13.8567 12.5028 14.2523 12.2111 14.5441C11.9193 14.8358 11.5237 14.9997 11.1111 14.9997H2.55556C2.143 14.9997 1.74733 14.8358 1.45561 14.5441C1.16389 14.2523 1 13.8567 1 13.4441V4.88856C1 4.476 1.16389 4.08034 1.45561 3.78862C1.74733 3.4969 2.143 3.33301 2.55556 3.33301H7.22222" stroke="#206FFD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.333 1H14.9997V5.66667" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6.44434 9.55556L14.9999 1" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Watch Tutorials
                    </Link> */}
                </div>
                <div className='steps-list'>
                    <ul>
                        <li>
                            <div className='number-checkmark'>
                                <div className='checkmark-div'>
                                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 6.66667L7.83333 12.5L18.3333 2" stroke="white" strokeWidth="3" strokeLinecap="round" />
                                    </svg>
                                </div>
                                {/* <div className='number-div'>
                                    1
                                </div> */}
                            </div>
                            <div className='step'>
                                <h3>Create your account</h3>
                                <p>Get your account ready to send cold emails that get replies.</p>
                            </div>
                            <div className='arrow-container'>
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div className='number-checkmark'>
                                <div className='checkmark-div'>
                                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 6.66667L7.83333 12.5L18.3333 2" stroke="white" strokeWidth="3" strokeLinecap="round" />
                                    </svg>
                                </div>
                                {/* <div className='number-div'>
                                    2
                                </div> */}
                            </div>
                            <div className='step'>
                                <h3>[New]Verify your email</h3>
                                <p>Verify your email  and activate outreach cold emails</p>
                            </div>
                            <div className='arrow-container'>
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </div>
                        </li>
                        <li>
                            {
                                emailProvider ?
                                    <>
                                        <div className='number-checkmark'>
                                            <div className='checkmark-div'>
                                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 6.66667L7.83333 12.5L18.3333 2" stroke="white" stroke-width="3" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className='step'>
                                            <h3>Connect your email provider</h3>
                                            {/* <p>Tell us which email you wanna use to send campaigns from.</p> */}
                                            <p>Connect email providers like Gmail or setup SMTP quickly to send and receive emails.</p>
                                        </div>
                                        <div className='arrow-container'>
                                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </>
                                    :
                                    <Link to="/settings/email-provider">
                                        <div className='number-checkmark'>
                                            <div className='number-div'>
                                                3
                                            </div>
                                        </div>
                                        <div className='step'>
                                            <h3>Connect your email provider</h3>
                                            {/* <p>Tell us which email you wanna use to send campaigns from.</p> */}
                                            <p>Connect email providers like Gmail or setup SMTP quickly to send and receive emails.</p>
                                        </div>
                                        <div className='arrow-container'>
                                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </Link>

                            }
                        </li>
                        <li>
                            {
                                campaignCreated ?
                                    <>
                                        <div className='number-checkmark'>
                                            <div className='checkmark-div'>
                                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 6.66667L7.83333 12.5L18.3333 2" stroke="white" stroke-width="3" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className='step'>
                                            <h3>Create your first campaign</h3>
                                            {/* <p>Integer tristique vel leo a feugiat. Pellentesque porta sapien magna,</p> */}
                                            <p>Start promoting your products or services with your first campaign</p>
                                        </div>
                                        <div className='arrow-container'>
                                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </>
                                    :
                                    emailProvider === false || emailProvider === null?
                                        <>
                                            <div className='number-checkmark'>
                                                <div className='number-div'>
                                                    4
                                                </div>
                                            </div>
                                            <div className='step'>
                                                <h3>Create your first campaign</h3>
                                                {/* <p>Integer tristique vel leo a feugiat. Pellentesque porta sapien magna,</p> */}
                                                <p>Start promoting your products or services with your first campaign</p>
                                            </div>
                                            <div className='arrow-container'>
                                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </>
                                        :
                                        <Link to="/campaign-name">
                                            <div className='number-checkmark'>
                                                <div className='number-div'>
                                                    4
                                                </div>
                                            </div>
                                            <div className='step'>
                                                <h3>Create your first campaign</h3>
                                                {/* <p>Integer tristique vel leo a feugiat. Pellentesque porta sapien magna,</p> */}
                                                <p>Start promoting your products or services with your first campaign</p>
                                            </div>
                                            <div className='arrow-container'>
                                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </Link>
                            }
                        </li>
                        <li>
                            {
                                campaignSent ?
                                    <>
                                        <div className='number-checkmark'>
                                            <div className='checkmark-div'>
                                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 6.66667L7.83333 12.5L18.3333 2" stroke="white" stroke-width="3" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className='step'>
                                            <h3>Send your campaign</h3>
                                            {/* <p>Create your sequence and start getting more replies.</p> */} 
                                            <p>Once everything is reviewed and tested, hit send</p>
                                        </div>
                                        <div className='arrow-container'>
                                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </>
                                    :
                                    campaignCreated === false ?
                                        <>
                                            <div className='number-checkmark'>
                                                <div className='number-div'>
                                                    5
                                                </div>
                                            </div>
                                            <div className='step'>
                                                <h3>Send your campaign</h3>
                                                {/* <p>Create your sequence and start getting more replies.</p> */}
                                                <p>Once everything is reviewed and tested, hit send</p>
                                            </div>
                                            <div className='arrow-container'>
                                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </>
                                        :
                                        <Link to='/create-campaign' >
                                            <div className='number-checkmark'>
                                                <div className='number-div'>
                                                    5
                                                </div>
                                            </div>
                                            <div className='step'>
                                                <h3>Send your campaign</h3>
                                                {/* <p>Create your sequence and start getting more replies.</p> */}
                                                <p>Once everything is reviewed and tested, hit send</p>
                                            </div>
                                            <div className='arrow-container'>
                                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.35" d="M1 1L6 6L1 11" stroke="#0A1E43" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </Link>
                            }
                        </li>
                    </ul>
                </div>
            </div>
            {/* <div className='dashboard-bottom-cols'>
                <Row>
                    <Col xs={6} md={4}>
                        <div className='bottom-post'>
                            <div className='icon-container'>
                                <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19" stroke="#FF5970" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z" stroke="#FF5970" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M23 18.9999V16.9999C22.9993 16.1136 22.7044 15.2527 22.1614 14.5522C21.6184 13.8517 20.8581 13.3515 20 13.1299" stroke="#FF5970" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 1.12988C16.8604 1.35018 17.623 1.85058 18.1676 2.55219C18.7122 3.2538 19.0078 4.11671 19.0078 5.00488C19.0078 5.89305 18.7122 6.75596 18.1676 7.45757C17.623 8.15918 16.8604 8.65958 16 8.87988" stroke="#FF5970" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h5>Community</h5>
                            <p>Join our friendly community and get in touch</p>
                            <Link to='/#'>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6667 8.77745V13.4441C12.6667 13.8567 12.5028 14.2523 12.2111 14.5441C11.9193 14.8358 11.5237 14.9997 11.1111 14.9997H2.55556C2.143 14.9997 1.74733 14.8358 1.45561 14.5441C1.16389 14.2523 1 13.8567 1 13.4441V4.88856C1 4.476 1.16389 4.08034 1.45561 3.78862C1.74733 3.4969 2.143 3.33301 2.55556 3.33301H7.22222" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.333 1H14.9997V5.66667" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.44434 9.55556L14.9999 1" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Join Slack
                            </Link>
                        </div>
                    </Col>
                    <Col xs={6} md={4}>
                        <div className='bottom-post'>
                            <div className='icon-container'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 16V10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10V16" stroke="#F4B800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M19 17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H16C15.4696 19 14.9609 18.7893 14.5858 18.4142C14.2107 18.0391 14 17.5304 14 17V14C14 13.4696 14.2107 12.9609 14.5858 12.5858C14.9609 12.2107 15.4696 12 16 12H19V17ZM1 17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H4C4.53043 19 5.03914 18.7893 5.41421 18.4142C5.78929 18.0391 6 17.5304 6 17V14C6 13.4696 5.78929 12.9609 5.41421 12.5858C5.03914 12.2107 4.53043 12 4 12H1V17Z" stroke="#F4B800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h5>Talk to an expert</h5>
                            <p>Need any help? Talk to us directly through chat</p>
                            <Link to='/#'>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6667 8.77745V13.4441C12.6667 13.8567 12.5028 14.2523 12.2111 14.5441C11.9193 14.8358 11.5237 14.9997 11.1111 14.9997H2.55556C2.143 14.9997 1.74733 14.8358 1.45561 14.5441C1.16389 14.2523 1 13.8567 1 13.4441V4.88856C1 4.476 1.16389 4.08034 1.45561 3.78862C1.74733 3.4969 2.143 3.33301 2.55556 3.33301H7.22222" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.333 1H14.9997V5.66667" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.44434 9.55556L14.9999 1" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Open the chat
                            </Link>
                        </div>
                    </Col>
                    <Col xs={6} md={4}>
                        <div className='bottom-post'>
                            <div className='icon-container'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 9.50003C19.0034 10.8199 18.6951 12.1219 18.1 13.3C17.3944 14.7118 16.3098 15.8992 14.9674 16.7293C13.6251 17.5594 12.0782 17.9994 10.5 18C9.18013 18.0035 7.87812 17.6951 6.7 17.1L1 19L2.9 13.3C2.30493 12.1219 1.99656 10.8199 2 9.50003C2.00061 7.92179 2.44061 6.37488 3.27072 5.03258C4.10083 3.69028 5.28825 2.6056 6.7 1.90003C7.87812 1.30496 9.18013 0.996587 10.5 1.00003H11C13.0843 1.11502 15.053 1.99479 16.5291 3.47089C18.0052 4.94699 18.885 6.91568 19 9.00003V9.50003Z" stroke="#3DD14C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h5>Send feedback</h5>
                            <p>Missing a feature or suggest an Improvement?</p>
                            <Link to='/#'>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6667 8.77745V13.4441C12.6667 13.8567 12.5028 14.2523 12.2111 14.5441C11.9193 14.8358 11.5237 14.9997 11.1111 14.9997H2.55556C2.143 14.9997 1.74733 14.8358 1.45561 14.5441C1.16389 14.2523 1 13.8567 1 13.4441V4.88856C1 4.476 1.16389 4.08034 1.45561 3.78862C1.74733 3.4969 2.143 3.33301 2.55556 3.33301H7.22222" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.333 1H14.9997V5.66667" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.44434 9.55556L14.9999 1" stroke="#206FFD" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Open the chat
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div> */}
        </div>
    )
}

export default Dashboard